import type { SidebarNavGroup, SidebarNavItem } from './sidebar-nav-item.interface'

export const buildNavUrl = (path: string, orgSlug: string | undefined): string => {
  if (!orgSlug) return path

  const normalizedPath = path === '/' ? '' : path.startsWith('/') ? path : `/${path}`
  return `/${orgSlug}${normalizedPath}`
}

export const getVisibleItems = (group: SidebarNavGroup, isExpanded: boolean): SidebarNavItem[] => {
  const { items, maxVisible } = group

  if (!maxVisible) return items

  if (isExpanded || items.length <= maxVisible) return items

  return items.slice(0, maxVisible)
}

export const shouldShowToggle = (group: SidebarNavGroup): boolean => {
  const { items, maxVisible } = group
  return !!maxVisible && items.length > maxVisible
}

export const getHiddenCount = (group: SidebarNavGroup): number => {
  const { items, maxVisible } = group
  if (!maxVisible) return 0
  return Math.max(0, items.length - maxVisible)
}
